var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"login",attrs:{"flat":""}},[_c('v-img',{staticClass:"my-3",attrs:{"src":require('@/assets/rlogo-loader_250.gif'),"contain":"","height":"200"}}),_c('p',[_vm._v("Authorizing...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }